module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-view-map"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 15,
      "options": {
        'styles': _vm.styles,
        'disableDefaultUI': true,
        'zoomControl': true
      }
    }
  }, [_vm._l((_vm.markers), function(marker, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": marker.position,
        "clickable": true,
        "draggable": false,
        "icon": {
          url: '/static/img/icon__map-pin.png'
        }
      },
      on: {
        "click": function($event) {
          _vm.onMarkerClick(marker.position, index)
        }
      }
    })
  }), _vm._v(" "), (_vm.infoWinOpen && _vm.selectedItemPosition) ? _c('gmap-info-window', {
    attrs: {
      "position": _vm.selectedItemPosition
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }, [_c('h3', {
    staticClass: "firstHeading",
    attrs: {
      "id": "firstHeading"
    }
  }, [_vm._v(_vm._s(_vm.selectedItem.name))]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        'name': 'Retailers Detail',
        'params': {
          'id': _vm.selectedItem.id
        }
      }
    }
  }, [_vm._v("View")])], 1)]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eef1e81a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ListViewMap/ListViewMap.vue
// module id = 567
// module chunks = 1